import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";
import { FlatpickrDirective, provideFlatpickrDefaults } from "angularx-flatpickr";

import { ChangeDetectionStrategy, Component, model } from "@angular/core";
import { FormsModule } from "@angular/forms";

@Component({
  selector: "malfunction-filter-period",
  templateUrl: "malfunction-filter-period.html",
  imports: [AngularSvgIconModule, FlatpickrDirective, FormsModule, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [provideFlatpickrDefaults()],
})
export class MalfunctionFilterPeriod {
  startDate = model.required<Date>();
  endDate = model.required<Date>();
}
